module.exports = __webpack_public_path__ + "static/img/M-8.d9a03fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/M-8.png
// module id = YqKk
// module chunks = 0